import { schema } from 'normalizr';

const BorrowerVariableConfigurationSchema = new schema.Entity('borrowerVariableConfigurations');

export default BorrowerVariableConfigurationSchema;
